import React, { useState } from "react";
import leftArrow from "../assets/images/About-Us/arrow_left.png";
import rightArrow from "../assets/images/About-Us/arrow_right.png";
import tnppog from "../assets/images/About-Us/tnppog.png";
import iarc from "../assets/images/About-Us/iafroc.png";
import inphog from "../assets/images/About-Us/inphog.png";
import cankids from "../assets/images/About-Us/cankids.png";
import aroh from "../assets/images/About-Us/aroh.png";
import st_jude from "../assets/images/About-Us/jude's.png";
import {
  FaChevronDown,
  FaChevronLeft,
  FaChevronRight,
  FaChevronUp,
} from "react-icons/fa";

const ChevronLeftIcon = FaChevronLeft as React.ComponentType<{
  "aria-hidden"?: boolean;
}>;
const ChevronRightIcon = FaChevronRight as React.ComponentType<{
  "aria-hidden"?: boolean;
}>;
const ChevronDownIcon = FaChevronDown as React.ComponentType<{
  "aria-hidden"?: boolean;
}>;
const ChevronUpIcon = FaChevronUp as React.ComponentType<{
  "aria-hidden"?: boolean;
}>;

const collaborators = [
  {
    name: "INPHOG",
    image: inphog,
  },
  {
    name: "TNPPOG",
    image: tnppog,
  },
  {
    name: "IARC",
    image: iarc,
  },
  {
    name: "CANKIDS",
    image: cankids,
  },
  {
    name: "AROH",
    image: aroh,
  },
  {
    name: "ST. JUDE CHILDRENS REASEARCH HOSPITAL",
    image: st_jude,
  },
];

const registryItems = [
  {
    title: "What is a Childhood Cancer Registry?",
    body: (
      <>
        <p>
          A Childhood Cancer Registry is a special cancer registry with a secure
          system that collects high-resolution data and manages information
          about children and adolescents diagnosed with cancer. It helps
          doctors, hospitals, researchers, and health authorities better
          understand childhood cancers and improve the care provided to every
          child.
        </p>
        <div className="about-question-box">
          <strong>
            The registry helps answer important questions such as:
          </strong>
          <ul>
            <li>How many children are diagnosed with cancer</li>
            <li>Which cancers are most common</li>
            <li>Disease stage at presentation to hospital</li>
            <li>What treatments are being used</li>
            <li>How children respond to treatment</li>
            <li>Survival and long-term outcomes</li>
          </ul>
        </div>
        <p>
          By bringing together information from hospitals and treatment centers,
          childhood cancer registries support research, improve patient care,
          guide health policies, and help identify gaps in cancer services for
          children.
        </p>
      </>
    ),
  },
  {
    title: "What is a Population-Based Childhood Cancer Registry (PBCCR)?",
    body: (
      <>
        <p>
          A Population-Based Childhood Cancer Registry (PBCCR) is a specialized
          registry that records all childhood cancer cases occurring within a
          defined geographic area - such as a city, district, or state -
          regardless of where the child receives treatment.
        </p>
        <p>
          Unlike hospital-based registries that collect information from a
          single institution, a PBCCR gathers data from multiple hospitals,
          laboratories, diagnostic centers, and healthcare facilities to ensure
          that every child with cancer in the population is counted.
        </p>
        <p>
          The PBCCR serves as an important healthcare data platform that helps
          in understanding childhood cancer incidence patterns, trends,
          outcomes, and regional disparities. By using secure digital data
          systems, the registry ensures strict data confidentiality while
          supporting doctors, researchers, and policy makers in strengthening
          childhood cancer care and improving outcomes.
        </p>
        <div className="about-question-box">
          <strong>A PBCCR helps to:</strong>
          <ul>
            <li>
              Measure the true burden of childhood cancer in the community
            </li>
            <li>Understand cancer incidence and trends over time</li>
            <li>Improve early diagnosis and access to treatment</li>
            <li>Plan healthcare services and resource allocation</li>
            <li>Support research and public health programs</li>
            <li>
              Strengthen national and global childhood cancer control efforts
            </li>
          </ul>
        </div>
        <p>
          Population-based registries are essential to ensure that every child
          with cancer is visible to the healthcare system and has the
          opportunity to receive timely and appropriate care.
        </p>
      </>
    ),
  },
  {
    title: "Tamil Nadu Population-Based Childhood Cancer Registry (TN PBCCR)",
    body: (
      <>
        <p>
          The Tamil Nadu Population-Based Childhood Cancer Registry (TN PBCCR)
          is a state-wide childhood cancer surveillance initiative developed to
          systematically record all childhood cancer cases diagnosed among
          children and adolescents aged 0-19 years across Tamil Nadu,
          irrespective of where they receive treatment. The TN PBCCR will cover
          approximately 6% of India's childhood population and about 4% of the
          country's geographic area, making it one of the largest dedicated
          population-based childhood cancer surveillance initiatives in India.
        </p>
        <p>
          The initiative began in August 2022 as the Chennai PBCCR at the Cancer
          Institute (WIA), Adyar, Chennai, India, making it the country's first
          dedicated PBCCR. Following successful implementation covering the
          Greater Chennai Corporation area with cooperation from oncologists in
          19 hospitals, the registry was expanded into the TN PBCCR in June 2025
          to strengthen childhood cancer surveillance across the state.
        </p>
        <p>
          The TN PBCCR is coordinated by the Cancer Institute (WIA), Adyar,
          Chennai, and is integrated with the Tamil Nadu Cancer Registry Program
          (TNCRP), a collaborative surveillance study with the Department of
          Health and Family Welfare, Government of Tamil Nadu. Tamil Nadu is one
          of the few states in India where cancer is a notifiable disease,
          providing a strong foundation for comprehensive childhood cancer
          surveillance.
        </p>
        <div className="about-question-box">
          <strong>The registry works in collaboration with:</strong>
          <ul>
            <li>
              Department of Health and Family Welfare, Tamil Nadu Government
            </li>
            <li>
              Government and private hospitals, especially oncology centers
            </li>
            <li>Government and private medical colleges</li>
            <li>
              Pathology laboratories, diagnostic centers, and imaging centers
            </li>
            <li>Daycare, palliative care, hospice, and support services</li>
            <li>Non-government organizations</li>
          </ul>
        </div>
        <p>
          Using active surveillance and standardized international methods, the
          TN PBCCR collects high-quality data on childhood cancer incidence,
          diagnosis, treatment, survival, and outcomes. It is being implemented
          in phases with the goal of covering all districts of Tamil Nadu.
        </p>
      </>
    ),
  },
];

const teamMembers = [
  {
    name: "Dr. Venkatraman Radhakrishnan",
    role: "PRINCIPAL INVESTIGATOR",
    // location: "CHENNAI",
    description:
      "Professor and Head, Department of Medical Oncology and Pediatric Oncology.",
    initials: "VR",
  },
  {
    name: "Dr. R Swaminathan",
    role: "CO-PRINCIPAL INVESTIGATOR",
    // location: "CHENNAI",
    description:
      "Professor and Head, Department of Epidemiology, Biostatistics and Cancer Registry. Associate Director.",
    initials: "RS",
  },
  {
    name: "Dr. Balaji T K",
    role: "CO-INVESTIGATOR",
    // location: "CHENNAI",
    description:
      "Assistant Professor, Department of Medical Oncology and Pediatric Oncology.",
    initials: "BT",
  },
  {
    name: "All participating institutions",
    role: "STAKEHOLDERS",
    // location: "TAMIL NADU",
    description:
      "Participating institutions supporting the Cancer Institute - Bagchi TN PBCCR study.",
    initials: "AI",
  },
];

const staffMembers = [
  {
    name: "Dr. Punitha Selvam",
    role: "PROJECT MANAGER",
    // location: "CHENNAI",
    // description:
    //   "Supporting project management, registry coordination, documentation, and implementation activities.",
    initials: "PS",
  },
  {
    name: "Ms. Ayswarya Jothi",
    role: "RESEARCH ASSOCIATE",
    // location: "CHENNAI",
    // description:
    //   "Supporting research coordination, field communication, registry documentation, and follow-up workflows.",
    initials: "AJ",
  },
  {
    name: "Ms. Vaishnavi Srinivasan",
    role: "DATA MANAGER (SOCIAL INVESTIGATOR)",
    // location: "CHENNAI",
    // description:
    //   "Social investigator supporting data management and registry follow-up for Chennai.",
    initials: "VS",
  },
  {
    name: "Ms. Sneha N",
    role: "DATA MANAGER (SOCIAL INVESTIGATOR)",
    // location: "CHENNAI",
    // description:
    //   "Social investigator supporting data management and registry follow-up for Chennai.",
    initials: "SN",
  },
  {
    name: "Ms. Gomathi E",
    role: "DATA MANAGER (SOCIAL INVESTIGATOR)",
    // location: "CHENNAI",
    // description:
    //   "Social investigator supporting data management and registry follow-up for Chennai.",
    initials: "GE",
  },
  {
    name: "Ms. Ezhilarasi D.R",
    role: "DATA MANAGER (SOCIAL INVESTIGATOR)",
    // location: "CHENNAI",
    // description:
    //   "Social investigator supporting data management and registry follow-up for Chennai.",
    initials: "ED",
  },
  {
    name: "Ms. Bavadharani A",
    role: "DATA MANAGER (SOCIAL INVESTIGATOR)",
    // location: "COIMBATORE",
    // description:
    //   "Social investigator supporting data management and registry follow-up for Coimbatore.",
    initials: "BA",
  },
  {
    name: "Ms. Sameena S",
    role: "DATA MANAGER (SOCIAL INVESTIGATOR)",
    // location: "TRICHY",
    // description:
    //   "Social investigator supporting data management and registry follow-up for Trichy.",
    initials: "SS",
  },
  {
    name: "Ms. Francina Veira S",
    role: "DATA MANAGER (SOCIAL INVESTIGATOR)",
    // location: "TIRUNELVELI",
    // description:
    //   "Social investigator supporting data management and registry follow-up for Tirunelveli.",
    initials: "FV",
  },
  {
    name: "Ms. Pavithira R",
    role: "DATA MANAGER (SOCIAL INVESTIGATOR)",
    // location: "MADURAI",
    // description:
    //   "Social investigator supporting data management and registry follow-up for Madurai.",
    initials: "PR",
  },
];

const About = () => {
  const [openRegistry, setOpenRegistry] = useState(0);

  return (
    <main className="about-page">
      <section className="about-sponsors">
        <h2>Sponsors</h2>
        <article>
          <h3>Bagchi Foundation</h3>
          <p>
            The Tamil Nadu Population-Based Childhood Cancer Registry (TNPBCCR)
            is grateful for the generous philanthropic support of Susmita Bagchi
            and Subroto Bagchi through the Bagchi Foundation. Their commitment
            to strengthening healthcare, public health, and cancer care in India
            has enabled the expansion and sustainability of the TNPBCCR, which
            aims to systematically document childhood cancer incidence,
            treatment, and outcomes across Tamil Nadu. This support contributes
            to building robust childhood cancer surveillance systems that can
            guide policy, improve access to care, and advance research and
            health system planning for children with cancer.
          </p>
        </article>
      </section>
      <section className="collaborators-section">
        <div className="collaborators-wrapper">
          <h2>Our Collaborators</h2>

          <p className="collaborators-subtitle">
            Partnering with leading organizations to advance cancer care,
            research, and innovation. Together, we are redefining the frontiers
            of precision oncology.
          </p>

          <div className="collaborators-card">
            {/* Left Arrow */}
            {/* <button className="arrow-btn left-arrow">
              <img src={leftArrow} alt="Previous" />
            </button> */}

            {/* Collaborators Grid */}
            <div className="collaborators-grid">
              {collaborators.map((item, index) => (
                <div className="collaborator-item" key={index}>
                  <img
                    src={item.image}
                    alt={item.name}
                    className="collaborator-logo"
                  />

                  <h4>{item.name}</h4>
                </div>
              ))}
            </div>

            {/* Right Arrow */}
            {/* <button className="arrow-btn right-arrow">
              <img src={rightArrow} alt="Next" />
            </button> */}
          </div>
        </div>
      </section>
      <section className="about-intro">
        <h1>About Cancer Institute (WIA)</h1>
        <p>
          The Cancer Institute (WIA), Adyar, Chennai, established in 1954, is a
          pioneering public charitable, not-for-profit institution dedicated to
          cancer care, research, education, prevention, and palliative care.
          Recognized as a State Cancer Institute and Regional Center for Cancer
          Research and Treatment, the Institute has been at the forefront of
          ethical and comprehensive cancer care in India for over seven decades.
        </p>
        <p>
          The Institute is a pioneer in cancer registration in India. The
          Hospital-Based Cancer Registry (HBCR) was established at the Institute
          in 1954, making it one of the earliest cancer registries in the
          country. The Madras Metropolitan Tumor Registry (MMTR), one of India's
          oldest Population-Based Cancer Registries (PBCRs), was established at
          the Institute in 1981 and has contributed significantly to cancer
          surveillance and research in India.
        </p>
        <p>
          The Cancer Institute (WIA) also leads the Tamil Nadu Cancer Registry
          Program (TNCRP), a statewide cancer surveillance initiative conducted
          in collaboration with the Department of Health and Family Welfare,
          Government of Tamil Nadu.
        </p>
        <p>
          Building on this strong registry infrastructure and expertise, the
          Cancer Institute (WIA) established the Chennai Population-Based
          Childhood Cancer Registry (PBCCR), India's first dedicated childhood
          PBCCR, and is now leading the expansion of the Tamil Nadu PBCCR to
          strengthen childhood cancer surveillance, research, and healthcare
          planning across Tamil Nadu through high-resolution data acquisition.
        </p>
      </section>

      <section className="about-registry">
        <h2>Understanding Childhood Cancer Registries</h2>
        <div className="about-registry-accordion">
          {registryItems.map((item, index) => {
            const isOpen = openRegistry === index;

            return (
              <article className="about-registry-item" key={item.title}>
                <button
                  type="button"
                  onClick={() => setOpenRegistry(isOpen ? -1 : index)}
                  aria-expanded={isOpen}
                >
                  <span>{item.title}</span>
                  <span className="about-registry-chevron" aria-hidden>
                    {isOpen ? (
                      <ChevronUpIcon aria-hidden />
                    ) : (
                      <ChevronDownIcon aria-hidden />
                    )}
                  </span>
                </button>
                {isOpen && (
                  <div className="about-registry-body">{item.body}</div>
                )}
              </article>
            );
          })}
        </div>
      </section>

      <TeamSection title="PBCCR Team" members={teamMembers} />
      <TeamSection title="PBCCR Staff" members={staffMembers} staff />
    </main>
  );
};

interface TeamSectionProps {
  title: string;
  members: Array<{
    name: string;
    role: string;
    description?: string;
    isPlaceholder?: boolean;
  }>;
  staff?: boolean;
}

const TeamSection = ({ title, members, staff = false }: TeamSectionProps) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const visibleCount = 3;
  const maxIndex = Math.max(members.length - visibleCount, 0);
  const visibleMembers = members.slice(activeIndex, activeIndex + visibleCount);

  const showPrevious = () => {
    setActiveIndex((current) => (current === 0 ? maxIndex : current - 1));
  };

  const showNext = () => {
    setActiveIndex((current) => (current === maxIndex ? 0 : current + 1));
  };

  return (
    <section
      className={`about-team-section${staff ? " about-staff-section" : ""}`}
    >
      <h2>{title}</h2>
      <button
        type="button"
        className="about-carousel-control about-carousel-left"
        onClick={showPrevious}
        aria-label={`Show previous ${title} cards`}
      >
        <ChevronLeftIcon aria-hidden />
      </button>
      <div className="about-member-grid">
        {visibleMembers.map((member, index) => (
          <article
            className={`about-member-card${
              member.isPlaceholder ? " about-member-placeholder" : ""
            }`}
            key={`${member.name}-${member.role}-${activeIndex + index}`}
          >
            {/* <div
              className="about-member-avatar"
              aria-label={`${member.name} profile placeholder`}
            >
              <span aria-hidden>{member.initials}</span>
            </div> */}
            <div className="about-member-tags">
              <span>{member.role}</span>
              {/* {member.location && <span>{member.location}</span>} */}
            </div>
            <h3>{member.name}</h3>
            {member.description && <p>{member.description}</p>}
          </article>
        ))}
      </div>
      <button
        type="button"
        className="about-carousel-control about-carousel-right"
        onClick={showNext}
        aria-label={`Show next ${title} cards`}
      >
        <ChevronRightIcon aria-hidden />
      </button>
    </section>
  );
};

export default About;
